import useEditorFormStats from 'dashboard/apps/InquiryTemplateEditor/hooks/useEditorFormStats';
import { Feature } from 'dashboard/models/inquiry-template-version';
import { ProductFeatureName } from 'dashboard/models/organization';
import useProductFeature from 'lib/hooks/useProductFeature';

export const MAX_STEPS_FOR_NON_ENHANCED = 20;
export const MAX_CONDITIONAL_STEP_FOR_NON_ENHANCED = 10;
export const MAX_ACTIONS_FOR_NON_ENHANCED = Infinity;
export const MAX_NON_INITIAL_STEP_ASSETS_FOR_NON_ENHANCED = 0;

// This hook takes, for each of some specified features, the number of additional instances
// of that feature to be used, and returns for each specified feature, a boolean describing
// whether that feature should be limited given the total number of resulting instances
export default ({
  [Feature.Step]: numAdditionalSteps = 1,
  [Feature.Action]: numAdditionalActions = 1,
  [Feature.Asset]: numAdditionalNonInitialStepImageHostedAssets = 1,
  [Feature.Conditional]: numAdditonalConditionalStep = 1,
} = {}): {
  [Feature.Step]: boolean;
  [Feature.Action]: boolean;
  [Feature.Asset]: boolean;
  [Feature.Conditional]: boolean;
} => {
  const { numSteps, numActions, numNonInitialStepImageHostedAssets, numConditionalSteps } =
    useEditorFormStats();
  const isInquiriesEnhanced = useProductFeature(ProductFeatureName.InquiriesEnhanced);
  const limitingRequired = !isInquiriesEnhanced;

  return {
    [Feature.Step]: numSteps + numAdditionalSteps > MAX_STEPS_FOR_NON_ENHANCED && limitingRequired,
    [Feature.Action]:
      numActions + numAdditionalActions > MAX_ACTIONS_FOR_NON_ENHANCED && limitingRequired,
    [Feature.Asset]:
      numNonInitialStepImageHostedAssets + numAdditionalNonInitialStepImageHostedAssets >
        MAX_NON_INITIAL_STEP_ASSETS_FOR_NON_ENHANCED && limitingRequired,
    [Feature.Conditional]:
      numConditionalSteps + numAdditonalConditionalStep > MAX_CONDITIONAL_STEP_FOR_NON_ENHANCED &&
      limitingRequired,
  };
};
